import { MultilinkStoryblok } from '@/lib/types/component-types-sb'
import Link from 'next/link'
import type { ComponentProps, PropsWithChildren } from 'react'

export function StoryblokLink({
  link,
  children,
  prefetch = false,
  ...props
}: PropsWithChildren<
  {
    link?: MultilinkStoryblok
  } & Omit<ComponentProps<typeof Link>, 'href' | 'target' | 'id'>
>) {
  const href = link?.linktype === 'story' ? `/${link?.cached_url ?? ''}` : link?.url

  // Do not prefetch external links
  const doPrefetch = prefetch && !href?.includes('http')

  if (!href) {
    return <div className={props.className}>{children}</div>
  }

  return (
    <Link
      href={href ?? ''}
      target={link?.target}
      id={link?.anchor}
      prefetch={doPrefetch}
      {...props}
    >
      {children}
    </Link>
  )
}
